/************
 * Developed by : Shiva Software Solutions
 * Date : 07-04-2022
 * Descriptions : Route page for view patient erx
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/
import React from 'react';

export const patienteRxRouteConfig = [
  {
    //Redirect to erx page
    routes: [
      {
        path: '/eRx/:erxid/:patientid',
        component: React.lazy(() => import('./eRx/index')),
      },
    ],
  },
];
